import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconWarningSignOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 19.667a1.333 1.333 0 1 1 0 2.666 1.333 1.333 0 0 1 0-2.666M16 12c.658 0 1.18.553 1.142 1.21l-.309 4.61a.835.835 0 0 1-1.666 0l-.309-4.61A1.144 1.144 0 0 1 16 12" /><path fill="currentColor" fillRule="evenodd" d="M16 3a1 1 0 0 1 .867.501l12.667 22A1 1 0 0 1 28.667 27H3.333a1 1 0 0 1-.867-1.499l12.667-22A1 1 0 0 1 16 3M5.064 25h21.872L16 6.004z" clipRule="evenodd" /></svg>;
export default SvgIconWarningSignOutlined;